import { Injectable } from '@angular/core';
import { ICustomerValidate } from '../../../core/models/customer.model';
import { EVALIDATION_STATUS as STATUS } from '../../../core/enums/customer.enum';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  public handleCustomerValidation(validation: ICustomerValidate): boolean {
    const { validation_status, can_request_validator } = validation as ICustomerValidate;

    if (validation_status === STATUS.PENDING && !can_request_validator) {
      return false;
    }

    if (validation_status === STATUS.APPROVED && !can_request_validator) {
      return true;
    }

    if (validation_status === STATUS.REJECTED && !!can_request_validator) {
      return true;
    }

    if (validation_status === STATUS.REJECTED && !can_request_validator) {
      return true;
    }

    if (validation_status === STATUS.ERROR && !can_request_validator) {
      return true;
    }

    if (validation_status === STATUS.ERROR && !!can_request_validator) {
      return true;
    }
  }
}
